import { PropsWithChildren } from 'react';

import styles from '../../WizardLayout.module.scss';

export const Footer = ({ children }: PropsWithChildren) => {
  return <footer className={styles.footer}>{children}</footer>;
};
